var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VxWalkthruSteps',{attrs:{"step":_vm.curStep,"steps":3,"loading":_vm.loading},on:{"update:step":function($event){_vm.curStep=$event}}},[_c('UpgradeStep',{attrs:{"step":1,"releases":_vm.upgrades}}),_c('CurrentReleaseStep',{attrs:{"step":2,"release":_vm.current}}),_c('DowngradeStep',{attrs:{"step":3,"releases":_vm.downgrades}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }